import { useCrossSellCart } from '../hooks/useCrossSellCart'
import OmpCrossSellCartDrawer from '../drawers/OmpCrossSellCartDrawer'
import OmpCrossSellAddedToast from './OmpCrossSellAddedToast'

// Draws the cross-sell cart drawer and its add / remove notification once for the whole portal,
// so the header's cart button and the section's cards open the same cart.
const OmpCrossSellCartHost = () => {
  const { cart, cartOpen, busy, notice, changeQuantity, remove, checkout, openCart, closeCart, closeNotice } =
    useCrossSellCart()

  return (
    <>
      <OmpCrossSellCartDrawer
        isOpen={cartOpen}
        cart={cart}
        busy={busy}
        onQuantityChange={changeQuantity}
        onRemove={remove}
        onCheckout={checkout}
        onClose={closeCart}
      />
      <OmpCrossSellAddedToast notice={notice} onViewCart={openCart} onClose={closeNotice} />
    </>
  )
}

export default OmpCrossSellCartHost
